"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultStepUIConfiguration = void 0;
exports.defaultStepUIConfiguration = {
    canRunInExecutionContainer: true,
    canUseExecutionTimeouts: true,
    useConfigurationUISection: true,
};
//# sourceMappingURL=StepUI.js.map